export const features = {
  VELOCITY_ENGAGE_CORPORATE_REPORT: 'VELOCITY_ENGAGE_CORPORATE_REPORT',
  CARFAX_DEALER: 'CARFAX_DEALER',
  VELOCITY_VENDOR: 'VELOCITY_VENDOR',
  STEP_REPORT_VERSION_2: 'STEP_REPORT_VERSION_2',
  STEP_REPORT_VERSION_3: 'STEP_REPORT_VERSION_3',
} as const;
